import { useState, useEffect } from "react";
import { Layout, Menu, Row, Col, Collapse, Button } from 'antd';
import setImageAbsoluteUrl from "../../utils/setImageAbosulteUrl";
import LoaderImg from '../../media/images/loader.gif';

const { Panel } = Collapse;
const { Sider, Content } = Layout;

const PaymentMethodsSection = ({ title, methods }) => (
  <Row gutter={[16, 16]} className='PaymentMethods-Row'>
    <Col span={4}>
      <p className='b5-body-400' 
				style={{ 
					textTransform: "uppercase", 
					top: '-15px', 
					position: 'absolute' ,
					fontWeight: 'bold'
				}}
			>{title}</p>
    </Col>
    <Col span={20}>
      <Row gutter={[16, 16]}>
				<div className="PaymentMethods-grid-container">
        	{methods.map((method, index) => (
						<div className="PaymentMethods-Col" key={index}>
							<img
                loading="lazy"
								className="PaymentMethods-logo"
								alt={method.name}
								src={setImageAbsoluteUrl(method.logo)}
							/>
						</div>
        	))}
				</div>
      </Row>
    </Col>
  </Row>
);

const Desktop = ({ paymentTypes, groupedData, handleMenuClick, selectedKey, selectedCountry, loading, lang, defaultRegion }) => {
  const [fadeClass, setFadeClass] = useState('fade-in');
  const [activeKey, setActiveKey] = useState(defaultRegion);
  const [selectedCountryTitle, setSelectedCountryTitle] = useState("");

  useEffect(() => {
    setTimeout(() => {}, 1500);
    if (loading) {
      setFadeClass('fade-in');
    } else {
      setFadeClass('fade-out');
    }
  }, [loading]);

  useEffect(() => {
    if (selectedCountry) {
      setSelectedCountryTitle(
        selectedCountry.nombres[lang]
          ? selectedCountry.nombres[lang]
          : selectedCountry.country
      );
    }
  }, [selectedCountry, lang]);
  
  const marketsDir = (lang) => {
    let dir = ''
    if (lang === 'en') {
      dir = 'markets'
    } else {
      dir = 'mercados'
    }
    return dir
  }
  const exploreTranslation = (lang) => {
    let explore = 'Explore market →'
    if (lang === 'pt') {
      explore = 'Explorar mercado →'
    } else if (lang === 'es') {
      explore = 'Explorar el mercado →'
    }
    return explore
  }

  useEffect(() => {
    if (defaultRegion) {
      setActiveKey(defaultRegion);
    }
  }, [defaultRegion]);
  
  
  return (
    <>
      {groupedData && (
        <Row>
          <Col span={24}>
            <Layout
              className="PaymentMethods-Container"
              style={{ minHeight: "700px" }}
            >
              <Sider
                theme="light"
                width={250}
                className="PaymentMethods-CountryList"
              >
                <Collapse
                  key={"accordion-payment-methods"}
                  ghost
                  accordion
                  expandIconPosition="end"
									defaultActiveKey={[defaultRegion]}
                  activeKey={activeKey} 
                  onChange={(key) => setActiveKey(key)}
                >
                  {Object.entries(groupedData).map(([region, countries]) => {                    
                    return (
                      <Panel
                        className="b4-body-400"
                        header={region}
                        key={region}
                        style={{
                          textTransform: "uppercase",
                          fontWeight: "700",
                        }}
                      >
                        {countries.length > 0 ? (
                          <Menu
                            mode="inline"
                            selectedKeys={[selectedKey]}
                            style={{
                              height: "100%",
                              borderRight: 0,
                              textTransform: "capitalize",
                            }}
                            onClick={handleMenuClick}
                          >
                            {countries.map((country) => {
                              const countryTitle = country.nombres[lang]
                                ? country.nombres[lang]
                                : country.country;
                              return (
                                <Menu.Item
                                  key={country.slug}
                                  className="b4-body-400"
                                >
                                  {countryTitle}
                                </Menu.Item>
                              );
                            })}
                          </Menu>
                        ) : console.log(`No countries for ${region}`)
                        }
                      </Panel>
                    )
                  })}
                </Collapse>
              </Sider>
              <Layout className="PaymentMethods-Container">
                <Content className="PaymentMethods-types">
                  <Row className="PaymentMethodDetail-title" style={{ alignItems: "center", padding: "20px 0" }}>
                    <div className="PaymentMethodDetail-country">
                      <img
                        loading="lazy"
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "50%",
                          marginRight: "20px",
                          border: "1px solid #EAEAEA",
                        }}
                        src={setImageAbsoluteUrl(selectedCountry?.thumbnail)}
                        alt={selectedCountry?.slug}
                      />
                      <h2
                        className="s1-subtitle-600"
                        style={{ color: "#0B1547" }}
                      >
                        {selectedCountryTitle}
                      </h2>
                    </div>
                    {selectedCountry?.showDetailLink == 'Yes' && (
                      <div>
                        <Button 
                          className="bt-medium-500" 
                          style={{color: '#0027F9' }} 
                          type="link" 
                          href={`/${lang}/${marketsDir(lang)}/${selectedCountry?.slug}`} 
                          variant="link">
                            {exploreTranslation(lang)}
                        </Button>
                      </div>
                    )}
                  </Row>
                  {loading ? (
                    <div
                      className={`PaymentMethods-Loader ${fadeClass}`}
                      style={{
                        display: loading ? "flex" : "none",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <img loading="lazy" src={LoaderImg} alt="loader" style={{ maxWidth: '300px'}}/>
                    </div>
                  ) : (
                    paymentTypes.map(({ title, methods }) => {
                      if (methods.length > 0)
                        return (
                          <PaymentMethodsSection
                            key={title}
                            title={title}
                            methods={methods}
                          />
                        );
                    })
                  )}
                </Content>
              </Layout>
            </Layout>
          </Col>
        </Row>
      )}
    </>
  );
};


export default Desktop;